import { Component, Injector } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { SearchDialogComponent } from '@Work/Accounts/proprietary/controls/search-dialog.component';
import { DataService } from '@Core/services/proprietary/data.service';
import { AppService } from '../../../../../core/services/proprietary/app.service';

@Component({
    standalone: false,
    selector: 'codeSet-search-dialog',
    templateUrl: './codeSet-search-dialog.component.html',
    providers: [DataService]
})
export class CodeSetSearchDialogComponent extends SearchDialogComponent {
    constructor(private injector: Injector, private activeModal: NgbActiveModal, public app: AppService) {
        super(injector);
    }

    initialize(): boolean {
        this.parentActiveModal = this.activeModal;

        if (!this.model.criteria.Set_Code) {
            throw 'No Set_Code found in criteria. A Set_Code is required for CodeSetSearchDialog';
        }

        this.objectType = 'CodeSet';
        this.model.title = 'Select '; // Set_Name will be added on when CodeSetGet returns

        this.model.criteria.Max = 500;
        this.model.criteria.Disabled_Ind = 'N';

        if (!this.model.criteria.View) {
            this.model.criteria.View = 'Full';
        }

        return true;
    }
}
